import { LatLng, LeafletMouseEvent } from 'leaflet';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Polygon, Polyline, PolylineProps } from 'react-leaflet';
import { getVectorEndCoords, getVectorStartCoords } from '../../../../helpers/geometry/vectorTool.helpers';
import { ISegmentationFeature } from '../../annotations.interface';
import { AnnotationToolType } from '../../submodules/annotationTypes/models/annotationToolType';
import { ISegmentationPolygonProps } from '../SegmentationLayerFeatures';

interface IVectorFeatureProps {
  isActive: boolean;
  feature: ISegmentationFeature;
  fillOpacity: number;
  latlngs: LatLng[];
  opacity: number;
  zoomLevel: number;
  onContextMenu: (e: LeafletMouseEvent) => void;
  onSegmentationOver: (e: LeafletMouseEvent) => void;
  onSegmentationOut: (e: LeafletMouseEvent) => void;
  onClick: (e: LeafletMouseEvent) => void;
}

export const VectorFeature = observer((props: IVectorFeatureProps): ReactElement => {
  const handleRef = (element: Polyline<ISegmentationPolygonProps & PolylineProps>): void => {
    if (props.isActive && element && 'enableEdit' in element.leafletElement && typeof element.leafletElement.enableEdit === 'function') {
      element.leafletElement.enableEdit();
    }
  };

  const id = props.feature.id;
  return (
    <div key={`${id}-vector-container`}>
      <Polyline<ISegmentationPolygonProps & PolylineProps>
        positions={getVectorStartCoords(props.latlngs[0], props.zoomLevel)}
        key={`${id}-start`}
        storeKey={`${id}-start`}
        color='orange'
        type={AnnotationToolType.VECTOR}
        onclick={props.onClick}
        onmouseover={props.onSegmentationOver}
        onmouseout={props.onSegmentationOut}
        oncontextmenu={props.onContextMenu}
        canRotate={false}
        opacity={props.opacity}
      />
      <Polygon<ISegmentationPolygonProps & PolylineProps>
        positions={getVectorEndCoords(props.latlngs, props.zoomLevel)}
        key={`${id}-end`}
        storeKey={`${id}-end`}
        color={props.feature.color}
        fillColor={props.feature.color}
        fillOpacity={props.opacity}
        type={AnnotationToolType.VECTOR}
        onclick={props.onClick}
        onmouseover={props.onSegmentationOver}
        onmouseout={props.onSegmentationOut}
        oncontextmenu={props.onContextMenu}
        canRotate={false}
        opacity={props.opacity}
      />
      <Polyline<ISegmentationPolygonProps & PolylineProps>
        key={id}
        storeKey={id}
        fillOpacity={props.fillOpacity}
        color={props.feature.color}
        type={AnnotationToolType.VECTOR}
        positions={props.latlngs}
        onclick={props.onClick}
        onmouseover={props.onSegmentationOver}
        onmouseout={props.onSegmentationOut}
        oncontextmenu={props.onContextMenu}
        canRotate={false}
        opacity={props.opacity}
        ref={handleRef}
      />
    </div>
  );
});
